// axios.js

import axios from 'axios'
// import Cookies from 'js-cookie';

axios.defaults.baseURL = '//chaobangai.com'

axios.defaults.withCredentials = true

axios.interceptors.request.use(config => {
  // const token = Cookies.get('accessToken');

  // // 如果存在 token，则添加到 URL 查询参数中
  // if (token) {
  //   // 使用 URLSearchParams 来安全地处理查询参数
  //   const url = new URL(config.url, config.baseURL || axios.defaults.baseURL)
  //   url.searchParams.set('accessToken', token)

  //   // 更新 config.url，只保留路径和查询字符串（去掉 origin 部分）
  //   config.url = url.pathname + url.search
  // }
  return config
}, error => {
  // 处理请求错误
  return Promise.reject(error)
})

axios.interceptors.response.use(response => {
  // 对响应数据做些什么
  return response
}, error => {
  // 处理响应错误
  return Promise.reject(error)
})

export default axios

